import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import { AccountInterface } from '../../store/mine_craft/accountsSlice';
import { uniq } from "../../helpers/ArrayHelpers";
import { devicesEntity } from "./devicesActions";
import { DeviceInterface } from "../../store/mine_craft/devicesSlice";
import { usersEntity } from "./usersActions";
import { UserInterface } from "../../store/mine_craft/usersSlice";

export const accountsEntity = new schema.Entity(
  'accounts',
  {
    device: devicesEntity,
    user:   usersEntity,
  }
);

const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      devices:  { [key: string]: DeviceInterface };
      users:    { [key: string]: UserInterface };
      accounts: { [key: string]: AccountInterface };
    }
  >(response.data.accounts, [accountsEntity]);

  return {
    devices:  normalized.entities?.devices  || {},
    users:    normalized.entities?.users    || {},
    accounts: normalized.entities?.accounts || {},
    ids:   uniq(normalized.result),
    count: response.data.meta?.total_count
  };
}

export const fetchAccounts = createAsyncThunk(
  'accounts/fetchAccounts',
  async (params: object = {}) => {
    const response = await mineCraftApi.get('/onesky/accounts', { params });
    return normalizeCollection(response);
  }
);
